import { Routes, Route, Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { languagePrefixes } from '../i18n';
import { useAuth } from '../components/authentication/AuthContext';
import NoSSR from '../components/data/NoSSR';
import SafeNavigate from '../components/ui/SafeNavigate';
import Home from './Home';
import AppHome from '../app/Home';
import SignUpPage from './authentication/SignUpPage';
import LoginPage from './authentication/LoginPage';
import ForgotPasswordPage from './authentication/ForgotPasswordPage';
import ResetPasswordPage from './authentication/ResetPasswordPage';
import Account from './authentication/Account';
import ProtectedRoute from '../app/ProtectedRoute';
import NotFound from './NotFound';
import Pricing from './Pricing';
import EarlyStageFoundersPage from './solutions/early-stage-startup-founders/EarlyStageFoundersPage';
import EstablishedBusinessesPage from './solutions/established-businesses/EstablishedBusinessesPage';
import AcceleratorsIncubatorsPage from './solutions/accelerators-incubators/AcceleratorsIncubatorsPage';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';
import RefundPolicy from './RefundPolicy';
import PricingPolicy from './PricingPolicy';
import TermsOfUse from './TermsOfUse';
import FindInvestors from './FindInvestors';
import InvestorProfile from '../components/investor-page/pInvestorProfile';
import FAQ from './FAQ';
import Blog from './Blog';
import SinglePost from '../components/blog/SinglePost';
import Lists from './Lists';
import SingleList from '../components/lists/SingleList';
import ThankYouPage from './payment/ThankYouPage';
import { MEMBERSHIP_ROUTE_ACCESS } from '../hooks/membership';

const routeDefinitions = [
  { path: '/', element: <Home /> },
  { path: '/app/*', element: <NoSSR><ProtectedRoute
    allowedMemberships={MEMBERSHIP_ROUTE_ACCESS.app}
  ><AppHome /> </ProtectedRoute></NoSSR>},
  { path: '/signup', element: <SignUpPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/login/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/account', element: <NoSSR><ProtectedRoute
    allowedMemberships={MEMBERSHIP_ROUTE_ACCESS.account}
  ><Account /></ProtectedRoute></NoSSR> },
  { path: '/pricing', element: <Pricing /> },
  { path: '/for-early-stage-startups', element: <EarlyStageFoundersPage /> },
  { path: '/for-established-businesses', element: <EstablishedBusinessesPage /> },
  { path: '/for-accelerators-and-incubators', element: <AcceleratorsIncubatorsPage /> },
  { path: '/cookie-policy', element: <CookiePolicy /> },
  { path: '/refund-policy', element: <RefundPolicy /> },
  { path: '/pricing-policy', element: <PricingPolicy /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/terms-and-conditions', element: <TermsOfUse /> },
  { path: '/find-investors', element: <FindInvestors /> },
  { path: '/investor-profile/:investorId', element: <InvestorProfile /> },
  { path: '/thank-you', element: <ThankYouPage /> },
  { path: '/blog', element: <Blog /> },
  { path: '/blog/:slug', element: <SinglePost /> },
  { path: '/lists', element: <Lists /> },
  { path: '/lists/:slug', element: <SingleList /> },
  { path: '/faq', element: <FAQ /> },
];

const WebsiteRoutes = () => {
  const languages = Object.keys(languagePrefixes);

  return (
    <Routes>
      {languages.map((lang) => (
        <Route key={lang} path={languagePrefixes[lang]} element={<Outlet />}> {/* Language wrapper */}
          {routeDefinitions.map((route) => (
            <Route
              key={`${lang}${route.path}`}
              path={route.path.replace(/^\/+/, '')}
              element={route.element}
            />
          ))}
        </Route>
      ))}
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<SafeNavigate to="/404" replace />} />
    </Routes>
  );
};

export default WebsiteRoutes;
